import { NoMatchPage } from "components/NoMatchPage";
import HistoryJobProvider from "context/jobProviders/HistoryJobProvider";
import { FC } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { HistoryDetailsPage } from "./HistoryDetailsPage";
import { HistoryVisitsPage } from "./HistoryVisitsPage";

const Router: FC = () => {
  const { id } = useParams();
  return (
    <Routes>
      <Route element={<HistoryJobProvider jobId={id} />}>
        <Route path="/*" element={<HistoryDetailsPage />} />
        <Route path="/visits" element={<HistoryVisitsPage />} />
      </Route>
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};
export default Router;
